export const ACTIVE = 1;
export const INACTIVE = 2;

export default Object.freeze({
  ACTIVE,
  INACTIVE
});
